import { ref } from 'vue';
import useAxiosAPI from '@global/composable/api/useAxiosAPI';

const { getFavoriteAPI, deleteFavoriteAPI, getDataAPI } = useAxiosAPI();
const dataIsLoad = ref(false);
const nowPage = ref(1);
const data = ref([]);
const totalPage = ref(null);
const totalCount = ref(0);

// 收藏頁
function spliceFavorite(index) {
  data.value.splice(index, 1);
  totalCount.value = data.value.length;
}

// 只有URL 是帶 PageSize = 21
function fetchItems(PageSize = 20) {
  const nowLocation = window.location.toString();

  if (nowLocation.indexOf('?') !== -1) {
    const args = nowLocation.split('?')[1].split('&');
    for (let i = 0; i < args.length; i++) {
      if (args[i].indexOf('P=') !== -1) {
        nowPage.value = parseInt(args[i].replace('P=', ''));
      }
    }
  } else {
    nowPage.value = 1;
  }

  getFavoriteAPI({
    params: {
      Page: nowPage.value,
      PageSize,
    },
  })
    .then((res) => {
      if (res.data.Code === 200) {
        dataIsLoad.value = true;
        totalPage.value = res.data.Response.PageCount;
        totalCount.value = res.data.Response.TotalCount;
        data.value = res.data.Response.Data;
      }
    })
    .catch((error) => {
      console.log(error);
    });
}

// 收藏項目
const dialogData = ref({
  isOpen: false,
  allData: {},
  selectedID: '',
  dataLoad: false,
  listName: '會員收藏清單',
});

function cancelFavorite(elCustomMarketID, idx) {
  deleteFavoriteAPI({
    data: { CustomMarketID: elCustomMarketID },
  })
    .then((res) => {
      if (res.data.Code === 200) {
        if (res.data.Response) {
          spliceFavorite(idx);
        }
      }
    })
    .catch((error) => {
      console.log(error);
    });
}

function showCartDialog(customMarketID) {
  getDataAPI({
    params: {
      customMarketID,
    },
  })
    .then((res) => {
      dialogData.value.isOpen = true;
      dialogData.value.allData = res.data.Response;
      dialogData.value.selectedID = res.data.Response.ColorID;
      dialogData.value.dataLoad = true;
    })
    .catch((error) => {
      console.log(error);
    });
}

function changeOpen(boolean) {
  dialogData.value.isOpen = boolean;
}
function changeSelect(colorID) {
  dialogData.value.selectedID = colorID;
}

function useFavorite() {
  return {
    dataIsLoad,
    data,
    totalPage,
    fetchItems,
    dialogData,
    cancelFavorite,
    showCartDialog,
    changeOpen,
    changeSelect,
  };
}

export default useFavorite;
